export class ColumnDetailPage {
  init(): void {
    // コラム詳細ページ
  }
}
